import ListGroupsTableRowGroup from './list-groups-table-row-group';
import ListGroupsTableRowGroupUsers from './list-groups-table-row-group-users';
function ListGroupTableRow({ group, refetchGroups, isExpanded, setSelectedGroup }) {
  return (
    <>
      <ListGroupsTableRowGroup
        group={group}
        setSelectedGroup={setSelectedGroup}
        isExpanded={isExpanded}
        refetchGroups={refetchGroups}
      />
      {isExpanded && <ListGroupsTableRowGroupUsers group={group} isExpanded={isExpanded} />}
    </>
  );
}

export default ListGroupTableRow;
